import { ResponsiveBar } from '@nivo/bar';

const _gridYValues = (minValue: number, maxValue: number) => {
    const step = maxValue - minValue;
    const scale = [minValue, step / 4, (step * 2) / 4, (step * 3) / 4, maxValue];
    return scale;
};

const margin = {
    top: 30,
    right: 10,
    bottom: 30,
    left: 10,
};

const borderColor: any = {
    from: 'color',
    modifiers: [['darker', 1.6]],
};

const NivoNakedBarChart = ({
    data,
    minValue,
    maxValue,
    noAnimate,
}: {
    data: any;
    minValue: number;
    maxValue: number;
    noAnimate: boolean;
}) => {
    const hasValidKeys = Array.isArray(data?.keys);
    const hasValidData = Array.isArray(data?.data);

    if (!hasValidKeys || !hasValidData) {
        return (
            <div className="chart-message">
                <span>Invalid chart data</span>
            </div>
        );
    }

    const gridYValues: any =
        minValue !== null && maxValue !== null ? _gridYValues(minValue, maxValue) : null;

    return (
        <ResponsiveBar
            animate={noAnimate !== true}
            enableGridX={false}
            enableGridY
            isInteractive={false}
            data={data.data}
            keys={data.keys}
            indexBy="id"
            margin={margin}
            padding={0.3}
            colors="#3a76af"
            borderColor={borderColor}
            axisTop={null}
            axisRight={null}
            axisBottom={null}
            axisLeft={null}
            labelSkipWidth={240}
            labelSkipHeight={240}
            labelTextColor="white"
            maxValue={maxValue != null ? maxValue : 'auto'}
            minValue={minValue != null ? minValue : 'auto'}
            gridYValues={gridYValues}
        />
    );
};

export default NivoNakedBarChart;
